"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorListProvider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const reselect_1 = require("reselect");
/**
 * Provides an ErrorList React Context for tracking a list of errors.
 * The list should be scoped to some reasonable context, such as a place page.
 * Children that emit errors can use ErrorReporter to do so, or add errors directly via addError.
 * Those errors can be handled by children that subscribe, such as ErrorToasts.
 */
class ErrorListProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.memoizedCreateErrorList = (0, reselect_1.defaultMemoize)(createErrorList);
        this.nextErrorId = 1;
        this.addError = (errorDisplayInfo) => {
            const errorId = `error_${this.nextErrorId++}`;
            const newError = Object.assign(Object.assign({}, errorDisplayInfo), { errorId });
            this.setState(prevState => ({
                errors: prevState.errors.concat(newError),
            }));
            return errorId;
        };
        this.removeError = (errorId) => {
            this.setState(prevState => ({
                errors: prevState.errors.filter(e => e.errorId !== errorId),
            }));
        };
        this.clearErrors = () => {
            this.setState({ errors: [] });
        };
        this.state = { errors: [] };
    }
    render() {
        const errorList = this.memoizedCreateErrorList(this.state.errors, this);
        return (react_1.default.createElement(data_catalog_shared_1.ErrorListContext.Provider, { value: errorList }, this.props.children));
    }
}
exports.ErrorListProvider = ErrorListProvider;
function createErrorList(errors, provider) {
    return {
        errors,
        addError: provider.addError,
        removeError: provider.removeError,
        clearErrors: provider.clearErrors,
    };
}
//# sourceMappingURL=ErrorListProvider.js.map